import React from 'react';
import LazyLoad from 'react-lazyload';
import { Box, Button, Container, Typography } from '@mui/material';
import GalleryBanner from 'components/GalleryBanner';
import GalleryHeroContainer from 'containers/gallery/GalleryHeroContainer';
import { makeStyles } from '@mui/styles';
import useIsMobile from 'hooks/useIsMobile';
import { useRouter } from 'next/router';
import { setLocale } from 'utils/locale';

import en from './locales/en';
import ja from './locales/en';
import zh from './locales/en';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';

const useStyles = makeStyles((theme) => ({
  buttonTag: {
    background: theme.palette.common.white,
    color: 'inherit',
    textTransform: 'none',
    fontSize: 15,
    border: '1px solid rgb(208, 208, 208)',
    borderRadius: 22,
    padding: theme.spacing(0.5, 2),
    margin: theme.spacing(0.5, 1),
  },
}));

export default function MainContent({ renderChildren, tagsData, onTagClick }) {
  const classes = useStyles();
  const isMobile = useIsMobile();
  const router = useRouter();
  const { locale } = router;
  const t = setLocale(locale, { en, es, fr, it, ja, zh });

  return (
    <>
      <Box bgcolor="#FAFAFA ">
        <Container>
          <GalleryHeroContainer />
        </Container>
      </Box>

      <Box bgcolor="#FFF" pb={10}>
        <Container>{renderChildren()}</Container>
      </Box>

      {tagsData && !isMobile && (
        <Box bgcolor="#EEEEEE" mt={-5} pb={6}>
          <Container>
            <Box py={4}>
              <Typography component="p" variant="h5">
                <b>{t.tags}</b>
              </Typography>
            </Box>

            {tagsData.tags.map((item) => (
              <Button className={classes.buttonTag} onClick={() => onTagClick(item)} key={item}>
                {item}
              </Button>
            ))}
          </Container>
        </Box>
      )}

      <LazyLoad offset={100}>
        <Box bgcolor="#5F29CC">
          <Container>
            <GalleryBanner />
          </Container>
        </Box>
      </LazyLoad>
    </>
  );
}
